import { Component, input, resource, inject, output, signal, ChangeDetectionStrategy } from "@angular/core";
import { RunnableReportConfiguration } from "../../../models/runnable_report";
import { ReportRunner } from "../../../services/report-runner";
import { ResourceWrapperComponent, RisrForm, RisrFormRenderer } from "@fry-it/risr-core";
import { MatCard, MatCardContent, MatCardActions } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { ReactiveFormsModule } from "@angular/forms";

@Component({
    selector: 'risr-features-reports-report-form',
    imports: [
        ResourceWrapperComponent,
        RisrFormRenderer,
        MatCard,
        MatCardContent,
        MatCardActions,
        MatButtonModule,
        ReactiveFormsModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './report-form.html',
})
export class ReportForm {
    report = input.required<RunnableReportConfiguration>();

    model = output<any | undefined>();
    private readonly initialModel = signal<any | undefined>({});
    private readonly reportRunner = inject(ReportRunner);

    protected buttonLabel = signal<string>($localize`Generate`);

    formResource = resource({
        params: () => {
          const report = this.report();
          const model = this.initialModel();
          if (!report || !model) {
            return undefined;
          }
          return {
            model: model,
            filterForm: report.filterForm
          };
        },
        loader: ({ params }) => {
          return this.reportRunner.getForm(params.filterForm, params.model);
        }
    })

    ngOnInit() {
      const report = this.report();
      if (!report) {
        return;
      }
      if (report.filterForm.length === 0) {
        this.buttonLabel.set($localize`Update`);
        this.model.emit(this.initialModel());
        return;
      }
    }

    submit(form: RisrForm) {
        if (!form.valid) {
            return;
        }
        this.initialModel.set(form.value());
        this.model.emit(form.value());
        this.buttonLabel.set($localize`Regenerate`);
    }


}
